import { useSelector } from 'react-redux';
import { RootState } from '@/lib/store';
import { UserRestriction } from '@/models/user-restriction';
import { useMemo } from 'react';
import RestrictionDetailsModalRestrictionsDetails from './Details';
import { Nullable } from '@starsoft/common/interfaces';
import { Restriction } from '@/models/restriction';

export default function RestrictionDetailsModalRestrictions() {
  const userRestrictions: UserRestriction[] = useSelector(
    (state: RootState) => state.userRestrictions.userRestrictions,
  );

  const restriction: Nullable<Restriction> = useSelector(
    (state: RootState) => state.userRestrictions.restriction,
  );

  if (!!restriction) {
    return (
      <RestrictionDetailsModalRestrictionsDetails
        key={`user-restriction-details-${restriction.id?.toString()}`}
        restriction={restriction}
        userRestriction={userRestrictions.find(
          userRestriction => userRestriction?.id === restriction?.id,
        )}
      />
    );
  }

  const Restrictions = useMemo(
    () =>
      userRestrictions?.map(userRestriction => {
        return (
          <RestrictionDetailsModalRestrictionsDetails
            key={`user-restriction-details-${userRestriction.id?.toString()}`}
            userRestriction={userRestriction}
            restriction={restriction}
          />
        );
      }),
    [userRestrictions],
  );

  return <>{Restrictions}</>;
}
